import React from 'react';
import data from './marketing_data.json';

// Shared chrome for the public, prerendered pages (marketing pages and the recipe book).
// Keep this free of browser-only APIs: it is rendered to static HTML at build time.

export const money = value => `$${value.toFixed(2).replace(/\.00$/, '')}`;
export const absolute = path => `${data.origin}${path}`;
export const youngOffer = data.youngFirstYearPrice;

export function StoreBadges({ className = '' }) {
  return <div className={`bt-stores ${className}`}>
    <a href={data.appStoreUrl}><img src="/marketing/app-store-badge.png" width="150" height="45" alt="Download BiteTracker on the App Store" loading="lazy" /></a>
    <a href={data.playStoreUrl}><img src="/marketing/google-play-badge.png" width="150" height="45" alt="Get BiteTracker on Google Play" loading="lazy" /></a>
  </div>;
}

export function SiteHeader({ path = '/' }) {
  const link = (href, label, active = path === href) => <a key={href} href={href} aria-current={active ? 'page' : undefined}>{label}</a>;
  return <header className="bt-header">
    <div className="bt-wrap">
      <a className="bt-brand" href="/">BiteTracker<span>Make every bite count.</span></a>
      <nav aria-label="Main navigation">
        {link('/pricing', 'Pricing')}
        {link('/recipe-book', 'Recipes', path === '/recipe-book' || path.startsWith('/recipe-book/'))}
        {link('/compare/myfitnesspal', 'Compare')}
        {link('/field-notes', 'Field Notes')}
        {link('/login', 'Log in')}
        <a className="bt-button bt-button-small" href="/signup">Start tracking</a>
      </nav>
    </div>
  </header>;
}

export function SiteFooter() {
  return <footer className="bt-footer">
    <div className="bt-wrap">
      <div className="bt-footer-brand">
        <a className="bt-brand" href="/">BiteTracker</a>
        <p>Calorie tracking that fits your everyday. Available on iPhone, Android and the web.</p>
        <StoreBadges />
      </div>
      <nav aria-label="Product">
        <h2>Product</h2>
        <a href="/pricing">Pricing &amp; discounts</a>
        <a href="/compare/myfitnesspal">MyFitnessPal alternative</a>
        <a href="/recipe-book">Healthy recipes</a>
        <a href="/field-notes">Food tracking guides</a>
        <a href="/signup">Create an account</a>
        <a href="/login">Log in</a>
      </nav>
      <nav aria-label="Company">
        <h2>Company</h2>
        <a href="/contact_us">Contact us</a>
        <a href="https://app.termly.io/document/privacy-policy/3026a771-41fe-46d9-8692-56615a8e1abb">Privacy policy</a>
        <a href="https://app.termly.io/document/terms-of-use-for-online-marketplace/7a82024e-d0ce-41f2-b415-1304f2adb087">Terms of use</a>
      </nav>
      <p className="bt-copyright">© {new Date().getFullYear()} BiteTracker. All rights reserved.</p>
    </div>
  </footer>;
}

export function organizationNode() {
  return { '@type': 'Organization', '@id': `${data.origin}/#organization`, name: 'BiteTracker', url: data.origin, logo: absolute('/logo512.png'), sameAs: [data.appStoreUrl, data.playStoreUrl] };
}

export function breadcrumbNode(trail) {
  return {
    '@type': 'BreadcrumbList',
    itemListElement: trail.map(([name, path], index) => ({ '@type': 'ListItem', position: index + 1, name, item: absolute(path) }))
  };
}

export default data;
